import React, { ReactNode } from 'react'

import { tva, twMerge } from '../../tailwind/merge'
import { HStack } from '../hstack'

export type PanelHeaderVariant = 'standard' | 'tall'

export interface PanelHeaderProps {
    variant?: PanelHeaderVariant
    className?: string
    children?: ReactNode
}

const panelHeader = tva({
    base: 'relative w-full shrink-0 flex-row items-center bg-background-sub-surface text-[1.125rem] font-light text-content-default',
    variants: {
        variant: {
            standard: 'h-[76px]',
            tall: 'h-[96px]',
        },
    },
})

export const PanelHeader = ({ variant = 'standard', className, children }: PanelHeaderProps) => (
    <HStack className={twMerge(panelHeader({ variant }), className)}>{children}</HStack>
)

PanelHeader.displayName = 'PanelHeader'
